module.exports = __webpack_public_path__ + "static/img/parallax2Opt-min.da8be2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/parallax2Opt-min.jpg
// module id = eyoR
// module chunks = 1